import { z } from "zod";
import { REGIONS } from "../../../misc";

export const getHolidaysQuerySchema = z.object({
	year: z.coerce.number(),
	state: z.enum(REGIONS),
});

export type GetHolidaysQuerySchema = z.infer<typeof getHolidaysQuerySchema>;
